import { useMutation } from '@tanstack/react-query'
import { UpdateBrincoForm } from 'src/@types/validations/BirthCertificate'
import { useAuth } from 'src/contexts/auth'
import { BirthCertificateController } from 'src/controllers/birth-certificate.controller'

const birthCertificateController = new BirthCertificateController()

export function useUpdateEarring() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationKey: ['updateEarring', farmId],
    mutationFn: (earringDto: Omit<UpdateBrincoForm, 'tempId'>) =>
      birthCertificateController.updateEarring(farmId!, earringDto)
  })
}
